module.exports = __webpack_public_path__ + "static/media/4.question.2c8c3993.mp4";